export default __webpack_public_path__ + "static/media/pic-4.c6ab0364.jpg";